export const LIPID_KEY_GROUPS = {
  cholesterol: [
    'chol',
    'cholesterol',
    'cho',
    'cholesterolresult',
    'lipidprofilecholesterol',
    'lipidprofilecholesterolresult',
    'totalcholesterol',
    'totalcholesterolresult',
  ],
  hdl: [
    'hdl',
    'hdlcholesterolresult',
    'lipidprofilehdl',
    'lipidprofilehdlresult',
  ],
  ldl: [
    'ldl',
    'ldlcholesterolresult',
    'lipidprofileldl',
    'lipidprofileldlresult',
  ],
  triglyceride: [
    'triglycerideresult',
    'lipidprofiletriglycerideresult',
    'lipidprofiletriglyceride',
    'triglyceride',
    'tg',
    'tri',
  ],
};

export const collectLabItems = (labData, keys = []) => {
  const collected = [];
  keys.forEach((key) => {
    if (labData?.[key]?.length > 0) {
      collected.push(...labData[key]);
    }
  });
  return collected;
};

export const toDbFormat = (items = []) =>
  (items || []).map((item) => ({
    value: item?.value,
    dateadd: item?.date,
    campaignid: item?.campaignid,
    memberid: item?.memberid,
  }));

export const mergeUniqueItems = (baseItems = [], extraItems = []) => {
  const seen = new Set(
    (baseItems || []).map((item) => `${item?.dateadd || ''}|${item?.value ?? ''}|${item?.campaignid || ''}|${item?.memberid || ''}`),
  );
  const merged = [...(baseItems || [])];

  (extraItems || []).forEach((item) => {
    const key = `${item?.dateadd || ''}|${item?.value ?? ''}|${item?.campaignid || ''}|${item?.memberid || ''}`;
    if (!seen.has(key)) {
      seen.add(key);
      merged.push(item);
    }
  });

  return merged.sort((a, b) => new Date(b?.dateadd || 0) - new Date(a?.dateadd || 0));
};

export const mergeLipidItemsWithMemberLab = ({
  cholesterolItems = [],
  hdlItems = [],
  ldlItems = [],
  triglycerideItems = [],
  memberLabData = null,
}) => {
  const labData = memberLabData?.labData;
  if (!labData) {
    return {
      cholesterolItems,
      hdlItems,
      ldlItems,
      triglycerideItems,
    };
  }

  return {
    cholesterolItems: mergeUniqueItems(
      cholesterolItems,
      toDbFormat(collectLabItems(labData, LIPID_KEY_GROUPS.cholesterol)),
    ),
    hdlItems: mergeUniqueItems(
      hdlItems,
      toDbFormat(collectLabItems(labData, LIPID_KEY_GROUPS.hdl)),
    ),
    ldlItems: mergeUniqueItems(
      ldlItems,
      toDbFormat(collectLabItems(labData, LIPID_KEY_GROUPS.ldl)),
    ),
    triglycerideItems: mergeUniqueItems(
      triglycerideItems,
      toDbFormat(collectLabItems(labData, LIPID_KEY_GROUPS.triglyceride)),
    ),
  };
};
